import { ActionTree, Module, MutationTree } from "vuex";
import { AppState, RootState } from "../type";
import { GetterTree } from "vuex";
import { apiAuthPlatformAdminMySelf, apiconfig } from "@/api/app";
import router, { filterAsyncRoutes } from "@/router";

const state: AppState = {
  permission: {},
  config: {},
  lang: ["zh_cn", "en"],
};

const getters: GetterTree<AppState, RootState> = {
  permission: (state) => state.permission,
  config: (state) => state.config,
  lang: (state) => state.lang,
};

const mutations: MutationTree<AppState> = {
  /**
   * @description 设置权限
   * @param { Object } state
   * @param { Array } data
   */
  setPermission(state, data) {
    state.permission = data;
  },
  /**
   * @description 设置配置
   * @param { Object } state
   * @param { Array } data
   */
  setCoonfig(state, data) {
    state.config = data;
  },
};

const actions: ActionTree<AppState, RootState> = {
  /**
   * @description 获取权限
   * @param { Object } state
   * @param { Function } commit
   */
  getPermission({ state, commit }) {
    return apiAuthPlatformAdminMySelf({ type: "M,C" }).then((res) => {
      commit("setPermissions", res.perms);
      let routes = filterAsyncRoutes(res.auth, true);
      commit("setPermission", { ...res, ...{ routes: routes } });
      return Promise.resolve({ ...res, ...{ routes: routes } });
    });
  },
  getConfig({ state, commit }) {
    return apiconfig().then((res) => {
      commit("setCoonfig", res);
      return Promise.resolve();
    });
  },
};

const app: Module<AppState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default app;
